/**
* @ngdoc directive
* @name Decimals
*
* @element input
*
* @description
  parses and formats ngModel according to format provided in decimals
  'money', 'percent', 'units' or any custom ($0,000.0) are available
*
* @attributes
* @param {Number} minValue - optional
* @param {Number} maxValue - optional
* @param {Boolean} showAsNegative - show as negative
*
* @example
  <input
    ng-init='value="0"'
    class='form-control'
    decimals='money'
    ng-model='value'
  />
*/

(function() {

  decimals.$inject = ["$timeout", "FORMAT"];
  app.directive('decimals', decimals);

  function decimals($timeout, FORMAT) {
    var directive = {
      restrict: 'A',
      require: '?ngModel',
      link: link,
      priority: 100
    };

    return directive;

    function link(scope, element, attr, ngModel) {
      var format = FORMAT[attr.decimals] || attr.decimals;

      init();

      function init() {
        setValidators();
        attr.$set('type', 'text');
        ngModel.$parsers.push(parseDecimal);
        ngModel.$formatters.push(formatDecimal);
      }

      function setValidators() {
        if (attr.maxValue) {
          ngModel.$validators.maxValue = function(modelValue, viewValue) {
            var isSuitable = modelValue === undefined || modelValue <= attr.maxValue;
            if (attr.originalTitle) checkTooltip(isSuitable);
            return isSuitable;
          };
        }
        if (attr.minValue) {
          ngModel.$validators.minValue = function(modelValue, viewValue) {
            return modelValue === undefined || modelValue >= attr.minValue;
          };
        }
      }

      function checkTooltip(isValueSuitable) {
        if (isValueSuitable) element.tooltip('destroy');
        else element.tooltip({ trigger: 'manual' }).tooltip('show');
      }

      function formatDecimal(value) {
        var value = numeral(value);
        if (isNaN(value.value())) value = numeral(0);
        if (attr.showAsNegative === 'true' && value.value() > 0) {
          value = numeral(value.value()*-1);
        }
        return value.format(format);
      }

      function parseDecimal(value) {
        var parsedValue = numeral().unformat(value);
        if (isNaN(parsedValue)) parsedValue = 0;
        var roundedValue = numeral().unformat(formatDecimal(parsedValue));
        if (attr.showAsNegative === 'true' && roundedValue < 0) {
          roundedValue *= -1;
        }
        return roundedValue;
      }


      // Formats the displayed value when the input field loses focus
      element.on('blur', function() {
        element.val(formatDecimal(element.val()));
      });

      element.on('focus', function(e) {
        $timeout(function () {
          try {
            element.get(0).setSelectionRange(0, 100);
          } catch (e) {
            try {
              element.get(0).select();
            } catch (e) {}
          }
        }, 20);
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/decimalsDirective.js